import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function ChallengeInnointelSearchContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success"
          ? "notifications.challengeInnointelSearchSuccess"
          : status === "pending"
            ? "notifications.challengeInnointelSearch"
            : "notifications.challengeInnointelSearchFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
